import Cookies from 'js-cookie'

export const TOKEN_KEY = 'auth_token'
export const REVIEW_TOKEN_KEY = 'ReviewUserWatch'
export const OPENID_KEY = 'WechatOpenId'
export const TUI_OPENID_KEY = 'TUI_WechatOpenId'

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: 14 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) {
    if (token.length > 10) {
      return token
    } else {
      Cookies.set(TOKEN_KEY, "", { expires: 14 })
    }
  }
  
  return ''
}

export const getReviewToken = () => {
  const token = Cookies.get(REVIEW_TOKEN_KEY)
  if (token) return token
  else return ''
}

export const setReviewToken = (token) => {
  Cookies.set(REVIEW_TOKEN_KEY, token, { expires: 14 })
}

export const removeToken = () => {
    const token = Cookies.get(TOKEN_KEY)
    if (token) Cookies.remove(TOKEN_KEY)
}

export const getWechatOpenId = () => {
  const token = Cookies.get(OPENID_KEY)
  if (token) return token
  else return ''
}

export const setWechatOpenId = (token) => {
  Cookies.set(OPENID_KEY, token, { expires: 14 })
}

export const getTuiWechatOpenId = () => {
  const token = Cookies.get(TUI_OPENID_KEY)
  if (token) return token
  else return ''
}

export const setTuiWechatOpenId = (token) => {
  console.log('setTuiWechatOpenId', token)
  Cookies.set(TUI_OPENID_KEY, token, { expires: 14 })
}


